import AuthNav from 'components/auth/AuthNav'
import ForgottenPassword from 'components/auth/ForgottenPassword'
import Login from 'components/auth/Login'
import Register from 'components/auth/Register'
import { FORGOTTEN_PASSWORD_PATH, LOGIN_PATH } from 'components/RouterSharedPaths'
import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'

const Container = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const isLoginSelected = useMemo(() => location.pathname === LOGIN_PATH, [location.pathname])

  return (
    <Wrapper>
      {
        location.pathname === FORGOTTEN_PASSWORD_PATH
          ?
            <ForgottenPassword onBack={ () => navigate(-1) } />
          : (
              <>
                <AuthNav
                  isLoginSelected={ isLoginSelected }
                />
                { isLoginSelected
                  ?
                    <Login />
                  :
                    <Register />
                }
              </>
            )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-self: center;
  width: 65%;
  padding: 3.7rem 0;
`

export default Container
